import React from "react";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import { bipcwithneet, homeImages, neetRankImages } from "./data";
import SeoMeta from "./seometa/seometa";
import RankridgeBIPCNEETPage from "./subcomponents/Rankridgebipcneet";
import CommonImageSliderRanks from "./CommonsliderRanks";
import { CommonAboutHeader } from "./CommonAboutHeader";
const seoBiPC = {
  title: "BiPC with NEET Coaching – Intermediate Colleges in Hyderabad",
  description: "Excel in NEET & board exams with Rankridge’s BiPC Intermediate integrated coaching. Experienced mentors & strong track record of top ranks.",
  keywords: "BiPC Junior College Hyderabad, NEET with BiPC Hyderabad, Best BiPC Junior College in Hyderabad, BiPC Intermediate Colleges Hyderabad, NEET Foundation Junior College Hyderabad, Junior Colleges with NEET Coaching, Best NEET Junior Colleges in Hyderabad, BiPC Residential Junior Colleges Hyderabad, BiPC Colleges with Hostel Facility Hyderabad, Best Residential BiPC Colleges Hyderabad, BiPC with NEET Coaching Hyderabad, NEET Coaching with BiPC Junior College, BiPC Junior College KPHB, Best BiPC Colleges Near Kukatpally, Top BiPC Junior Colleges Near Hitech City, Rankridge BiPC Junior College, Rankridge NEET Foundation, Best NEET Preparation Junior College Hyderabad, NEET Coaching Junior College Hyderabad, Junior College for NEET Coaching Hyderabad, BiPC with Medical Foundation Hyderabad, BiPC Intermediate Course Hyderabad, BiPC Junior College Admissions Hyderabad, Best Junior Colleges for NEET Coaching, Best BiPC Colleges for Medical Aspirants, Top BiPC Residential Colleges Hyderabad",
  canonical_path: "https://www.rankridge.com/best-neet-coaching-center-in-hyderbad/",
  og_description: "",
  og_image: "",
};

const BipcWithNeet = () => {
  return (
    <div>
      {/* <h1 className="text-3xl sm:text-sm md:text-4xl font-extrabold text-center text-[#20b2aa] mb-12">
         Rankridge – The Best BIPC College in Hyderabad with NEET Coaching
      </h1>
     
 
      <CommonAboutHeader images={bipcwithneet}/>
       <div className="mb-1 mt- me-2 ms-2">
       <CommonImageSliderRanks images={neetRankImages}/>


<CallandRegisterComponent />
</div> */}
<section>
<RankridgeBIPCNEETPage />

</section>



      

       <SeoMeta seopages={seoBiPC} />
    </div>
  );
};

export default BipcWithNeet;
